import { useStyles } from './styles'
import { DailyBonusWrapper } from '../dailyBonus'
import { useUnit } from 'effector-react'
import { claimDailyBonusFx, getDailyBonusInfoFx } from '@/entities/dailyBonus/model/effects'
import { $userToken } from '@/entities/user'
import { useState } from 'react'
import WebApp from '@twa-dev/sdk'
import { DailyBonusRowProps } from '../types'
import { DailyBonusSeparator } from '@/shared/ui/dailyBonusSeparator'
import { getCaseListFx } from '@/entities/cases/effects'
export const DefaultDailyBonusRow = (props: DailyBonusRowProps) => {
  const { defaultReward, premiumReward, currentDay } = props

  const { classes } = useStyles()
  const userToken = useUnit($userToken)

  const rewardDay = defaultReward.day

  const interactableRow = premiumReward.can_claim || defaultReward.can_claim || rewardDay <= currentDay

  const [isFetching, setIsFetching] = useState([false, false])

  const handleClaimDailyBonus = async (isPremiumReward: boolean) => {
    if (WebApp.platform === 'ios' || WebApp.platform === 'android') {
      for (let i = 0; i < 2; i++) {
        setTimeout(() => {
          WebApp.HapticFeedback.impactOccurred('light')
        }, 50 * i)
      }
    }
    setIsFetching(isPremiumReward ? [true, false] : [false, true])
    try {
      await claimDailyBonusFx({ token: userToken!, day: rewardDay, isPremium: isPremiumReward })
    } finally {
      await getDailyBonusInfoFx(userToken!)
      if (rewardDay === 7) {
        getCaseListFx({ token: userToken! })
      }
      setIsFetching([false, false])
    }
  }

  return (
    <div
      className={classes.root}
      data-isfaded={!interactableRow}
    >
      <div
        className={classes.dailyBonusWrapperContainer}
        data-daystatus={
          interactableRow
            ? premiumReward.is_claimed
              ? 'gray'
              : 'current'
            : premiumReward.is_claimed
            ? 'gray'
            : 'previous'
        }
      >
        <DailyBonusWrapper
          isLoading={isFetching[0]}
          amount={premiumReward.reward}
          rewardKind={premiumReward.kind}
          isShowingLocker={!premiumReward.can_claim}
          isClaimed={premiumReward.is_claimed}
          isDisabled={!premiumReward.can_claim}
          onClick={() => handleClaimDailyBonus(true)}
        />
      </div>
      <DailyBonusSeparator day={rewardDay} />

      <div
        className={classes.dailyBonusWrapperContainer}
        data-inactive={!interactableRow}
        style={{
          backgroundImage: defaultReward.is_claimed
            ? 'radial-gradient(circle,rgb(124, 124, 124) 0%, #1D1E22 80%)'
            : 'radial-gradient(circle,rgb(19, 113, 175) 0%, #1D1E22 80%)',
          backgroundPosition: 'center',
          filter: isFetching[1] ? 'grayscale(100%)' : 'none',
          transition: 'filter 0.2s ease-in-out',
        }}
      >
        <DailyBonusWrapper
          isLoading={isFetching[1]}
          amount={defaultReward.reward}
          rewardKind={defaultReward.kind}
          isShowingLocker={!defaultReward.can_claim}
          isClaimed={defaultReward.is_claimed}
          isDisabled={!defaultReward.can_claim}
          onClick={() => handleClaimDailyBonus(false)}
        />
      </div>
    </div>
  )
}
